<template>
    <layout-main :banner="banner" subtitle="WIFI网络解决方案">
        <template v-slot:content>
            <p class="text">迪孚科技专为医疗行业提供WIFI网络解决方案、物联网数分平台解决方案，提供400-7125MHz全频段无线网络，802.11ac/ax/be/AC/Zig Bee/RFID/NBIoT/LoRa，为医生、护士提供最佳使用体验网络由基站负责无线信号的输出，将IEEE802.11ac/ax/be标准无线独立信道，经过技术处理输出到分布式天线系统。根据不同的应用环境和需求，可以选择不同DEFOE iNET分布式天线系统。</p>
            <img src="@/assets/wifiNetwork/image1.png" alt="" class="image1">
        
            <p class="text">· 根据覆盖场景度身设计，保证信号覆盖均匀、无缝、稳定、高强度和高灵敏度</p>
            <p class="text">· DEFOE iNET分布式天线系统确保移动终端零切换、数据零丢包，保证实时数据交换</p>
            <p class="text">· 分布式天线系统采用一个病区安装一台基站模式，基站统一安装在机房内</p>
            <p class="text">· 能保证有源设备运行环境和物理安全，简化维护程序</p>
            <p class="text">· 利用不重叠信道做覆盖，减少信道干扰，避免丢包</p>
            <p class="text">· 支持通过升级来提高整体系统的带宽容量，能升级多种型号，扩展性强</p>
            <p class="text">· 全系列产品提供多信道负载均衡、冗余备份或单信道热备功能</p>
            <p class="text">· 支持创建多个虚拟网络，有针对性的提供不同的QoS和安全接入控制机制。</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '../../components/layout-main.vue'
import banner from '@/assets/wifiNetwork/banner.png';
export default {
    components: {
        layoutMain,
        
    },
    data () {
        return {
            banner: banner
        }
    }
}
</script>
<style lang="scss" scoped>
 .text{
        line-height: 2;
    }
    .image1{
        width: 70%;
        margin: 50px 0;
    }
</style>
